import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ConfigurationCategoryDto } from '../type/dto/ConfigurationCategoryDto'
import { ConfigurationElementAdapter } from './ConfigurationElementAdapter'
import { ConfigCategory } from '../type/ConfigCategory'

export class ConfigurationCategoryAdapter implements ApiDataAdapter<ConfigCategory> {
    public createClass(category: ConfigurationCategoryDto): ConfigCategory {
        return {
            key: category.key,
            label: category.label,
            description: category.description,
            configs: Object.values(category._ref_configurations).map(config =>
                new ConfigurationElementAdapter().createClass(config),
            ),
        }
    }
}
